<lib-prod-form [fields]="fields" (onSubmitEvent)="submit($event)" [data]="dialogData.data"></lib-prod-form>

